import { FulfillmentGroupData } from "@redotech/redo-model/fulfillments/fulfillment-group";
import { createContext, memo, ReactNode, useContext, useState } from "react";
import {
  CarrierAccountsContext,
  CarrierAccountsProvider,
} from "../carrier-accounts-context";
import { CreateReturnLabelModal } from "./create-return-label-modal";

export const CreateReturnLabelModalContext = createContext<
  (fulfillmentGroup: FulfillmentGroupData) => void
>(() => {});

export const CreateReturnLabelModalProvider = memo(
  function CreateReturnLabelModalProvider({
    children,
  }: {
    children: ReactNode;
  }) {
    const [fulfillmentGroup, setFulfillmentGroup] =
      useState<FulfillmentGroupData | null>(null);
    const [open, setOpen] = useState(false);
    const carrierAccountsContext = useContext(CarrierAccountsContext);

    const openModalWithGroup = (newFulfillmentGroup: FulfillmentGroupData) => {
      setFulfillmentGroup(newFulfillmentGroup);
      setOpen(true);
    };

    const handleCloseModal = () => {
      setOpen(false);
      setFulfillmentGroup(null);
    };

    const modal = fulfillmentGroup ? (
      carrierAccountsContext === undefined ? (
        <CarrierAccountsProvider>
          <CreateReturnLabelModal
            closeModal={handleCloseModal}
            fulfillmentGroup={fulfillmentGroup}
            isOpen={open}
            key={fulfillmentGroup._id}
          />
        </CarrierAccountsProvider>
      ) : (
        <CreateReturnLabelModal
          closeModal={handleCloseModal}
          fulfillmentGroup={fulfillmentGroup}
          isOpen={open}
          key={fulfillmentGroup._id}
        />
      )
    ) : null;

    return (
      <CreateReturnLabelModalContext.Provider value={openModalWithGroup}>
        {children}
        {modal}
      </CreateReturnLabelModalContext.Provider>
    );
  },
);
